module.exports = __webpack_public_path__ + "img/07.54998920.png";